let listeners = [];
let resolveCallbacks = {};

export function subscribeToasts(fn) {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((x) => x !== fn);
  };
}

export function toast(message, type = "info", opts = {}) {
  const id = `${Date.now()}_${Math.random().toString(16).slice(2)}`;
  const duration = opts.duration ?? 4000;

  const payload = {
    id,
    message,
    type,
    duration,
  };

  if (type === "confirm") {
    return new Promise((resolve) => {
      resolveCallbacks[id] = resolve;
      payload.resolveId = id;
      listeners.forEach((fn) => fn(payload));
    });
  }

  listeners.forEach((fn) => fn(payload));
  return id;
}

export function updateToast(toastId, newMessage, newType = null) {
  const payload = {
    id: toastId,
    message: newMessage,
    type: newType,
  };

  listeners.forEach((fn) => fn(payload));
}

export function resolveConfirm(toastId, result) {
  if (resolveCallbacks[toastId]) {
    resolveCallbacks[toastId](result);
    delete resolveCallbacks[toastId];
  }
}

toast.loading = (message) => toast(message, "loading");
toast.update = (toastId, newMessage, newType = null) => {
  updateToast(toastId, newMessage, newType);
  return toastId;
};
toast.success = (m, o) => toast(m, "success", o);
toast.error = (m, o) => toast(m, "error", o);
toast.warn = (m, o) => toast(m, "warn", o);
toast.info = (m, o) => toast(m, "info", o);
toast.confirm = (m, o) => toast(m, "confirm", o);